module.exports = __webpack_public_path__ + "alto.png?6a93be34a7e4a584e1b19ca294a27abd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alto.png
// module id = 950
// module chunks = 2